module.exports = __webpack_public_path__ + "static/grafika4-d0294521f602298c6b31e11c630de961.png";